// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .styles_CommentPlugin_CommentInputBox__jGgt8 {
    position: absolute;
    /* z-index: 24; */

    display: block;

    width: 450px;
    min-height: 80px;
    background-color: #fff;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    z-index: 100;
    animation: styles_show-input-box__BvHJZ 0.4s ease;

    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0 0 5px 0 rgb(0 0 0 / 10%);
  }
  
  
  .styles_CommentPlugin_CommentInputBox_Buttons__0U\\+S9 {
    display: flex;
    flex-direction: row;

    padding: 0 10px 10px;
    gap: 10px;
  }
  
  .styles_CommentPlugin_CommentInputBox_Button__JQvFS {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  
  .styles_CommentPlugin_CommentInputBox_EditorContainer__ADmL3 {
    position: relative;
    margin: 10px 10px;
    border-radius: 5px;
  }
  .styles_CommentPlugin__EditorContainer__6DkDd {
    position: relative;
    margin: 10px 0;
    border-radius: 5px;
  }
  
  .styles_CommentPlugin_CommentInputBox_Editor__0HP2c {
    position: relative;

    display: block;
    overflow-y: auto;

    min-height: 80px;
    padding: 9px 10px 10px 9px;

    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #fff;

    font-size: 15px;
    caret-color: rgb(5 5 5);
  }
  
  .styles_CommentPlugin_CommentInputBox_Editor__0HP2c:focus {
    outline: 1px solid rgb(66 135 245);
  }
  
  
  .styles_CommentPlugin_CommentsPanel__kh3oz {
    position:absolute;
    height: -webkit-max-content;
    height: max-content;
    justify-self:end;
    margin-left: auto;
    /* min-height:200px; */
    width:300px;
    border: 1px solid rgba(230, 233, 237, 1);
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    /* height: calc(100% - 220px); */
    animation: styles_show-comments__Tg5zT 0.2s ease;
    border-radius: 2px;
    /* overflow-y: scroll; */
    overflow: hidden;
    /* top: 237px; */
    /* bottom: 20px; */
    
  }

  /* @media (max-width: 1845px) {
    .CommentPlugin_CommentsPanel {
      top: 325px;
      right: 20px;

      height: calc(100% - 250px);
    }
  } */
  
  @keyframes styles_show-comments__Tg5zT {
    0% {
      transform: translateX(300px);

      opacity: 0;
    }

    100% {
      transform: translateX(0);

      opacity: 1;
    }
  }
  
  .styles_CommentPlugin_CommentsPanel_Editor__8H82n {
    position: relative;
    overflow-x: hidden;
    display: block;
    overflow-y: auto;

    min-height: 40px;
    
    padding: 9px 30px 10px 9px;

    border: 1px solid #ccc;
    border-radius: 5px;
    outline: none;
    background-color: #fff;

    font-size: 15px;
    caret-color: rgb(5 5 5);
  }
  .styles_commentRead__JKPhk {
    position: relative;
    outline: none;
    display: block;
    overflow-y: auto;
    min-height: 20px;
    
    padding: 0 1px 5px 9px;
    font-size: 15px;
    caret-color: rgb(5 5 5);
  }
  

  
  .styles_CommentPlugin_CommentsPanel_List__vXZIr {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  .styles_CommentPlugin_CommentsPanel_List_Comment__JUWPQ {
    position: relative;
    padding:5px 8px 5px 1px;
    width: 100%;
    margin: 0;
    /* padding: 15px 8px 5px 15px; */

    transition: all 0.2s linear;

    background-color: rgba(245, 246, 247, 1);

    font-size: 14px;

  }
  
  .styles_CommentPlugin_CommentsPanel_List_Comment__JUWPQ p {
    margin: 0;

    color: #444;
  }
  
  .styles_CommentPlugin_CommentsPanel_List_Details__IjLVD {
    padding:10px 8px 5px 20px;
    

    vertical-align: top;

    color: #444;
  }
  
  .styles_CommentPlugin_CommentsPanel_List_Comment_Author__PlCuO {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding-right: 5px;

    font-weight: bold;
  }
  
  .styles_CommentPlugin_CommentsPanel_List_Comment_Time__z5fGW {
    color: #999;
  }
  
  .styles_CommentPlugin_CommentsPanel_List_Thread__e-DyS {
    /* border-bottom: 1px solid #eee; */
    position: relative;

    margin: 0;
    padding: 0;

    transition: all 0.2s linear;

    /* border-left: 0 solid #eee; */
  }
  
  .styles_CommentPlugin_CommentsPanel_List_Thread__e-DyS:first-child,
  .styles_CommentPlugin_CommentsPanel_List_Thread__e-DyS
    + .styles_CommentPlugin_CommentsPanel_List_Thread__e-DyS {
    border-top: none;
  }
  
  .styles_CommentPlugin_CommentsPanel_List_Comment__JUWPQ.styles_interactive__raBVH {
    cursor: pointer;
  }
  
  .styles_CommentPlugin_CommentsPanel_List_Comment__JUWPQ.styles_active__e0CSr {
    cursor: inherit;

    background-color: white;
    box-shadow: 0 4px 12px 0 rgb(0 20 67 / 12%);
  }
  
  
  .styles_CommentPlugin_CommentsPanel_List_Thread_QuoteBox__zxeQD {
    display: block;

    color: #ccc;
    background-color: green;
  }
  
  .styles_CommentPlugin_CommentsPanel_List_Thread_Quote__QTd5q {
    margin: 0;
  }
  
  .styles_CommentPlugin_CommentsPanel_List_Thread_Quote__QTd5q span {
    display: inline;

    padding: 1px;

    color: #222;
    background-color: rgb(255 212 0 / 40%);

    font-weight: bold;
    line-height: 1.4;
  }
  
  .styles_CommentPlugin_CommentsPanel_List_Thread_Comments__IfRyQ {
    padding-left: 0;
    padding-right: 0;
    list-style-type: none;
background-color: rgba(245, 246, 247, 1);
    border-top: 1px solid #eee;
  }
  
  .styles_CommentPlugin_CommentsPanel_List_Thread_Comments__IfRyQ
    .styles_CommentPlugin_CommentsPanel_List_Comment__JUWPQ:first-child.styles_CommentPlugin_CommentsPanel_List_Comment__JUWPQ:last-child {
    padding-bottom: 5px;
  }
  
  .styles_CommentPlugin_CommentsPanel_List_Thread_Comments__IfRyQ
    .styles_CommentPlugin_CommentsPanel_List_Comment__JUWPQ {
      padding-left: 5px;
  }
  
  .styles_CommentPlugin_CommentsPanel_List_Thread_Editor__Yl6Q6 {
    position: relative;
    background-color: #F5F6F7;
    padding:10px 8px 5px 20px;
    overflow: hidden;
    
  }
  
  .styles_CommentPlugin_CommentsPanel_List_DeleteButton__EyWEq {
    position: absolute;
    top: 10px;
    right: 10px;

    width: 30px;
    height: 30px;

    opacity: 0;
    background-color: transparent;
  }
  
  .styles_CommentPlugin_CommentsPanel_DeletedComment__S9GUd,
  .styles_CommentPlugin_CommentsPanel_List_Comment__JUWPQ:hover
    .styles_CommentPlugin_CommentsPanel_List_DeleteButton__EyWEq,
  .styles_CommentPlugin_CommentsPanel_List_Thread_QuoteBox__zxeQD:hover
    .styles_CommentPlugin_CommentsPanel_List_DeleteButton__EyWEq {
    opacity: 0.5;
  }
  
  .styles_CommentPlugin_CommentsPanel_List_DeleteButton__EyWEq:hover {
    opacity: 1;
    background-color: transparent;
    filter: invert(45%) sepia(98%) saturate(2299%) hue-rotate(201deg)
      brightness(100%) contrast(92%);
  }
  .styles_markSelected__JhwRe * {
    background-color: #FFEA9E !important;
  }

  .styles_placeholder__wa9Gw {
    position: absolute;
    top: 10px;
    left: 10px;

    overflow: hidden;

    width: 178px;

    -webkit-user-select: none;

            user-select: none;
    white-space: nowrap;
    text-overflow: ellipsis;
    pointer-events: none;

    color: rgba(178, 181, 187, 1);

    font-size: 14px;
  }`, "",{"version":3,"sources":["webpack://./src/components/form/Editor/plugins/CommentPlugin/styles.module.css"],"names":[],"mappings":";EACE;IACE,kBAAkB;IAClB,iBAAiB;;IAEjB,cAAc;;IAEd,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,wCAAwC;IACxC,kBAAkB;IAClB,YAAY;IACZ,iDAAmC;;IAEnC,kBAAkB;IAClB,sBAAsB;IACtB,sCAAsC;EACxC;;;EAGA;IACE,aAAa;IACb,mBAAmB;;IAEnB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;;EAGA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;;IAElB,cAAc;IACd,gBAAgB;;IAEhB,gBAAgB;IAChB,0BAA0B;;IAE1B,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;;IAEtB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,kCAAkC;EACpC;;;EAGA;IACE,iBAAiB;IACjB,2BAAmB;IAAnB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,wCAAwC;IACxC,+CAA+C;IAC/C,gCAAgC;IAChC,gDAAkC;IAClC,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;;EAEpB;;EAEA;;;;;;;KAOG;;EAEH;IACE;MACE,4BAA4B;;MAE5B,UAAU;IACZ;;IAEA;MACE,wBAAwB;;MAExB,UAAU;IACZ;EACF;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;;IAEhB,gBAAgB;;IAEhB,0BAA0B;;IAE1B,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;;IAEtB,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,gBAAgB;;IAEhB,sBAAsB;IACtB,eAAe;IACf,uBAAuB;EACzB;;;;EAIA;IACE,WAAW;IACX,SAAS;IACT,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,SAAS;IACT,gCAAgC;;IAEhC,2BAA2B;;IAE3B,wCAAwC;;IAExC,eAAe;;EAEjB;;EAEA;IACE,SAAS;;IAET,WAAW;EACb;;EAEA;IACE,yBAAyB;;;IAGzB,mBAAmB;;IAEnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,kBAAkB;;IAElB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mCAAmC;IACnC,kBAAkB;;IAElB,SAAS;IACT,UAAU;;IAEV,2BAA2B;;IAE3B,+BAA+B;EACjC;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;;IAEf,uBAAuB;IACvB,2CAA2C;EAC7C;;;EAGA;IACE,cAAc;;IAEd,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;;IAEf,YAAY;;IAEZ,WAAW;IACX,sCAAsC;;IAEtC,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB,wCAAwC;IACpC,0BAA0B;EAC5B;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;MAEI,iBAAiB;EACrB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;;EAElB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;;IAEX,WAAW;IACX,YAAY;;IAEZ,UAAU;IACV,6BAA6B;EAC/B;;EAEA;;;;;IAKE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,6BAA6B;IAC7B;oCACgC;EAClC;EACA;IACE,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;;IAEV,gBAAgB;;IAEhB,YAAY;;IAEZ,yBAAiB;;YAAjB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;;IAEpB,6BAA6B;;IAE7B,eAAe;EACjB","sourcesContent":["\n  .CommentPlugin_CommentInputBox {\n    position: absolute;\n    /* z-index: 24; */\n\n    display: block;\n\n    width: 450px;\n    min-height: 80px;\n    background-color: #fff;\n    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n    z-index: 100;\n    animation: show-input-box 0.4s ease;\n\n    border-radius: 5px;\n    background-color: #fff;\n    box-shadow: 0 0 5px 0 rgb(0 0 0 / 10%);\n  }\n  \n  \n  .CommentPlugin_CommentInputBox_Buttons {\n    display: flex;\n    flex-direction: row;\n\n    padding: 0 10px 10px;\n    gap: 10px;\n  }\n  \n  .CommentPlugin_CommentInputBox_Button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  \n  .CommentPlugin_CommentInputBox_EditorContainer {\n    position: relative;\n    margin: 10px 10px;\n    border-radius: 5px;\n  }\n  .CommentPlugin__EditorContainer {\n    position: relative;\n    margin: 10px 0;\n    border-radius: 5px;\n  }\n  \n  .CommentPlugin_CommentInputBox_Editor {\n    position: relative;\n\n    display: block;\n    overflow-y: auto;\n\n    min-height: 80px;\n    padding: 9px 10px 10px 9px;\n\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    background-color: #fff;\n\n    font-size: 15px;\n    caret-color: rgb(5 5 5);\n  }\n  \n  .CommentPlugin_CommentInputBox_Editor:focus {\n    outline: 1px solid rgb(66 135 245);\n  }\n  \n  \n  .CommentPlugin_CommentsPanel {\n    position:absolute;\n    height: max-content;\n    justify-self:end;\n    margin-left: auto;\n    /* min-height:200px; */\n    width:300px;\n    border: 1px solid rgba(230, 233, 237, 1);\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n    /* height: calc(100% - 220px); */\n    animation: show-comments 0.2s ease;\n    border-radius: 2px;\n    /* overflow-y: scroll; */\n    overflow: hidden;\n    /* top: 237px; */\n    /* bottom: 20px; */\n    \n  }\n\n  /* @media (max-width: 1845px) {\n    .CommentPlugin_CommentsPanel {\n      top: 325px;\n      right: 20px;\n\n      height: calc(100% - 250px);\n    }\n  } */\n  \n  @keyframes show-comments {\n    0% {\n      transform: translateX(300px);\n\n      opacity: 0;\n    }\n\n    100% {\n      transform: translateX(0);\n\n      opacity: 1;\n    }\n  }\n  \n  .CommentPlugin_CommentsPanel_Editor {\n    position: relative;\n    overflow-x: hidden;\n    display: block;\n    overflow-y: auto;\n\n    min-height: 40px;\n    \n    padding: 9px 30px 10px 9px;\n\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    outline: none;\n    background-color: #fff;\n\n    font-size: 15px;\n    caret-color: rgb(5 5 5);\n  }\n  .commentRead {\n    position: relative;\n    outline: none;\n    display: block;\n    overflow-y: auto;\n    min-height: 20px;\n    \n    padding: 0 1px 5px 9px;\n    font-size: 15px;\n    caret-color: rgb(5 5 5);\n  }\n  \n\n  \n  .CommentPlugin_CommentsPanel_List {\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n  }\n\n  .CommentPlugin_CommentsPanel_List_Comment {\n    position: relative;\n    padding:5px 8px 5px 1px;\n    width: 100%;\n    margin: 0;\n    /* padding: 15px 8px 5px 15px; */\n\n    transition: all 0.2s linear;\n\n    background-color: rgba(245, 246, 247, 1);\n\n    font-size: 14px;\n\n  }\n  \n  .CommentPlugin_CommentsPanel_List_Comment p {\n    margin: 0;\n\n    color: #444;\n  }\n  \n  .CommentPlugin_CommentsPanel_List_Details {\n    padding:10px 8px 5px 20px;\n    \n\n    vertical-align: top;\n\n    color: #444;\n  }\n  \n  .CommentPlugin_CommentsPanel_List_Comment_Author {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    padding-right: 5px;\n\n    font-weight: bold;\n  }\n  \n  .CommentPlugin_CommentsPanel_List_Comment_Time {\n    color: #999;\n  }\n  \n  .CommentPlugin_CommentsPanel_List_Thread {\n    /* border-bottom: 1px solid #eee; */\n    position: relative;\n\n    margin: 0;\n    padding: 0;\n\n    transition: all 0.2s linear;\n\n    /* border-left: 0 solid #eee; */\n  }\n  \n  .CommentPlugin_CommentsPanel_List_Thread:first-child,\n  .CommentPlugin_CommentsPanel_List_Thread\n    + .CommentPlugin_CommentsPanel_List_Thread {\n    border-top: none;\n  }\n  \n  .CommentPlugin_CommentsPanel_List_Comment.interactive {\n    cursor: pointer;\n  }\n  \n  .CommentPlugin_CommentsPanel_List_Comment.active {\n    cursor: inherit;\n\n    background-color: white;\n    box-shadow: 0 4px 12px 0 rgb(0 20 67 / 12%);\n  }\n  \n  \n  .CommentPlugin_CommentsPanel_List_Thread_QuoteBox {\n    display: block;\n\n    color: #ccc;\n    background-color: green;\n  }\n  \n  .CommentPlugin_CommentsPanel_List_Thread_Quote {\n    margin: 0;\n  }\n  \n  .CommentPlugin_CommentsPanel_List_Thread_Quote span {\n    display: inline;\n\n    padding: 1px;\n\n    color: #222;\n    background-color: rgb(255 212 0 / 40%);\n\n    font-weight: bold;\n    line-height: 1.4;\n  }\n  \n  .CommentPlugin_CommentsPanel_List_Thread_Comments {\n    padding-left: 0;\n    padding-right: 0;\n    list-style-type: none;\nbackground-color: rgba(245, 246, 247, 1);\n    border-top: 1px solid #eee;\n  }\n  \n  .CommentPlugin_CommentsPanel_List_Thread_Comments\n    .CommentPlugin_CommentsPanel_List_Comment:first-child.CommentPlugin_CommentsPanel_List_Comment:last-child {\n    padding-bottom: 5px;\n  }\n  \n  .CommentPlugin_CommentsPanel_List_Thread_Comments\n    .CommentPlugin_CommentsPanel_List_Comment {\n      padding-left: 5px;\n  }\n  \n  .CommentPlugin_CommentsPanel_List_Thread_Editor {\n    position: relative;\n    background-color: #F5F6F7;\n    padding:10px 8px 5px 20px;\n    overflow: hidden;\n    \n  }\n  \n  .CommentPlugin_CommentsPanel_List_DeleteButton {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n\n    width: 30px;\n    height: 30px;\n\n    opacity: 0;\n    background-color: transparent;\n  }\n  \n  .CommentPlugin_CommentsPanel_DeletedComment,\n  .CommentPlugin_CommentsPanel_List_Comment:hover\n    .CommentPlugin_CommentsPanel_List_DeleteButton,\n  .CommentPlugin_CommentsPanel_List_Thread_QuoteBox:hover\n    .CommentPlugin_CommentsPanel_List_DeleteButton {\n    opacity: 0.5;\n  }\n  \n  .CommentPlugin_CommentsPanel_List_DeleteButton:hover {\n    opacity: 1;\n    background-color: transparent;\n    filter: invert(45%) sepia(98%) saturate(2299%) hue-rotate(201deg)\n      brightness(100%) contrast(92%);\n  }\n  .markSelected * {\n    background-color: #FFEA9E !important;\n  }\n\n  .placeholder {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n\n    overflow: hidden;\n\n    width: 178px;\n\n    user-select: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    pointer-events: none;\n\n    color: rgba(178, 181, 187, 1);\n\n    font-size: 14px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CommentPlugin_CommentInputBox": `styles_CommentPlugin_CommentInputBox__jGgt8`,
	"show-input-box": `styles_show-input-box__BvHJZ`,
	"CommentPlugin_CommentInputBox_Buttons": `styles_CommentPlugin_CommentInputBox_Buttons__0U+S9`,
	"CommentPlugin_CommentInputBox_Button": `styles_CommentPlugin_CommentInputBox_Button__JQvFS`,
	"CommentPlugin_CommentInputBox_EditorContainer": `styles_CommentPlugin_CommentInputBox_EditorContainer__ADmL3`,
	"CommentPlugin__EditorContainer": `styles_CommentPlugin__EditorContainer__6DkDd`,
	"CommentPlugin_CommentInputBox_Editor": `styles_CommentPlugin_CommentInputBox_Editor__0HP2c`,
	"CommentPlugin_CommentsPanel": `styles_CommentPlugin_CommentsPanel__kh3oz`,
	"show-comments": `styles_show-comments__Tg5zT`,
	"CommentPlugin_CommentsPanel_Editor": `styles_CommentPlugin_CommentsPanel_Editor__8H82n`,
	"commentRead": `styles_commentRead__JKPhk`,
	"CommentPlugin_CommentsPanel_List": `styles_CommentPlugin_CommentsPanel_List__vXZIr`,
	"CommentPlugin_CommentsPanel_List_Comment": `styles_CommentPlugin_CommentsPanel_List_Comment__JUWPQ`,
	"CommentPlugin_CommentsPanel_List_Details": `styles_CommentPlugin_CommentsPanel_List_Details__IjLVD`,
	"CommentPlugin_CommentsPanel_List_Comment_Author": `styles_CommentPlugin_CommentsPanel_List_Comment_Author__PlCuO`,
	"CommentPlugin_CommentsPanel_List_Comment_Time": `styles_CommentPlugin_CommentsPanel_List_Comment_Time__z5fGW`,
	"CommentPlugin_CommentsPanel_List_Thread": `styles_CommentPlugin_CommentsPanel_List_Thread__e-DyS`,
	"interactive": `styles_interactive__raBVH`,
	"active": `styles_active__e0CSr`,
	"CommentPlugin_CommentsPanel_List_Thread_QuoteBox": `styles_CommentPlugin_CommentsPanel_List_Thread_QuoteBox__zxeQD`,
	"CommentPlugin_CommentsPanel_List_Thread_Quote": `styles_CommentPlugin_CommentsPanel_List_Thread_Quote__QTd5q`,
	"CommentPlugin_CommentsPanel_List_Thread_Comments": `styles_CommentPlugin_CommentsPanel_List_Thread_Comments__IfRyQ`,
	"CommentPlugin_CommentsPanel_List_Thread_Editor": `styles_CommentPlugin_CommentsPanel_List_Thread_Editor__Yl6Q6`,
	"CommentPlugin_CommentsPanel_List_DeleteButton": `styles_CommentPlugin_CommentsPanel_List_DeleteButton__EyWEq`,
	"CommentPlugin_CommentsPanel_DeletedComment": `styles_CommentPlugin_CommentsPanel_DeletedComment__S9GUd`,
	"markSelected": `styles_markSelected__JhwRe`,
	"placeholder": `styles_placeholder__wa9Gw`
};
export default ___CSS_LOADER_EXPORT___;
